import * as angular from "angular";
import {IController} from "angular";

export class depotLinkCtrl implements IController {

  depot: any;
  address: any;
  phone: string;
  additionalPhone: string;

  constructor() {

  }

  $onInit() {

  }

}

angular
  .module('bringoz.admin.depots')
  .component('depotLink', {
    bindings: {
      depot: '<',
      address: '<?',
      phone: '<?',
      additionalPhone: '<?'
    },
    template: require('./depot-link.html').default,
    controller: depotLinkCtrl
  });


